/* eslint-disable */
import { AppBar, Box, Dialog, InputBase, IconButton, TextField, Toolbar, Typography, Slide, Button, DialogTitle, Grid, FormControlLabel, Checkbox, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import { ReactComponent as ThreeDotsIcon } from "../Assets/svg/ThreeDotsIcon.svg";
import { ReactComponent as PhoneIcon } from "../Assets/svg/PhoneIcon.svg";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as ArrowRightIcon } from "../Assets/svg/ArrowRightIcon.svg";
import { ReactComponent as CloseIcon } from "../Assets/svg/CloseIcon.svg";
import { ReactComponent as LabelsIcon } from "../Assets/svg/LabelsIcon.svg";
import { ReactComponent as HouseIcon } from "../Assets/svg/HouseIcon.svg";
import { ReactComponent as ShareIcon } from "../Assets/svg/ShareIcon.svg";
import { ReactComponent as SendIcon } from "../Assets/svg/SendIcon.svg";
import { ReactComponent as CalendarIcon } from "../Assets/svg/CalendarIcon.svg";
import { ReactComponent as PenIcon } from "../Assets/svg/PenIcon.svg";
import { ReactComponent as BackUpIcon } from "../Assets/svg/BackUpIcon.svg";
import { ReactComponent as DelIcon } from "../Assets/svg/DelIcon.svg";
import { ReactComponent as MailIcon } from "../Assets/svg/MailIcon.svg";
import { ReactComponent as RoundArrowsIcon } from "../Assets/svg/RoundArrowsIcon.svg";
import { ReactComponent as SettingIcon } from "../Assets/svg/SettingIcon.svg";
import { ReactComponent as PlusGreenIcon } from "../Assets/svg/PlusGreenIcon.svg";
import { ReactComponent as GreenArrow } from "../Assets/svg/greenArrow.svg";
import { ReactComponent as CheckIcon } from "../Assets/svg/CheckIcon.svg";
import { ReactComponent as PlusIcon } from "../Assets/svg/PlusIcon.svg";
import { ReactComponent as SettingDarkGray } from "../Assets/svg/SettingDarkGray.svg";
import moment from "moment-jalaali"
import jalaliMoment from "jalali-moment"
import { useUserStore } from '../store/user';
import http from '../api/axiosInstance';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import DatePicker, { DateObject } from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en";
import PropertyContactModal from "./PropertyContactModal";
import { CheckPermissions } from "./CheckPermissions";
// import UserItem from '../Pages/settings/Components/UserItem';
import Snackbar from '@mui/material/Snackbar';
import ModalComponent from "./ModalComponent";
import { getUserToken, lightOrDark, newShade } from "./PublicFunctions";
import {
    Picker,
    format,
    newDate,
    DatePickerConfig,
} from '@persian-tools/persian-mobile-datepicker';
import { config } from '../Components/persian-mobile-datepicker-config'
import ShareOnSocial from "react-share-on-social";
import { messageTemplate } from "../api/ListData";
import ShareModal from "./ShareComponent";
import Remember from "./Remember";
import RelationsModal from "./RelationsModal";
import Cookies from 'js-cookie'
import ShareModalCompo from "./ShareModal";
import SetLabelsModal from "./SetLabelsModal";
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
    props,
    ref,
) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator
            valueIsNumericString
            prefix=""
        />
    );
});

NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

function PropItem(props) {
    const [openMoreOptionsModal, setOpenMoreOptionsModal] = useState(false)
    const [openLabelsModal, setOpenLabelsModal] = useState(false)
    const [buyLoading, setBuyLoading] = useState(false)
    const [sendOtpLoading, setSendOtpLoading] = useState(false)
    const [openOtpCode, setOpenOtpCode] = useState(false)
    const [otpCode, setOtpCode] = useState("")
    const [openBackdrop, setOpenBackdrop] = React.useState(false);
    const [ContactModal, setContactModal] = useState(false);
    const [mobileModal, setMobileModal] = useState(false);
    const [sendMobileLoading, setSendMobileLoading] = useState(false);
    const [archiveModal, setArchiveModal] = useState(false);
    const [commissionPrice, setCommissionPrice] = useState(null);
    const [showCommissionPrice, setShowCommissionPrice] = useState("");
    const [commissionUsers, setCommissionUsers] = useState([
        { AgencyId: "", Price: "", Name: "" }
    ]);
    const [openUsersModal, setOpenUsersModal] = useState(false)
    const [shareModal, setShareModal] = useState(false)
    const [indexUserSelected, setIndexUserSelected] = useState(null)
    const [commissionUsersLoading, setCommissionUsersLoading] = useState(false)
    const [ContractCancelled, setContractCancelled] = useState(0)
    const [HasRentReminder, setHasRentReminder] = useState(0)
    const [RentReminderDate, setRentReminderDate] = useState("")
    const [labelsLoading, setLabelsLoading] = useState(false);
    const [relationsModal, setRelationModal] = useState(false);
    const [labels, setLabels] = useState([]);
    const [textTemplate, setTextTemplate] = useState('');
    const [buyingDesc, setBuyingDesc] = useState(false);

    const [rememberModal, setRememberModal] = useState(false);
    const [rememberState, setRememberState] = useState({
        EntityId: "",
        EntityType: "property",
        DueDate: "",
        RemindDays: "",
        Title: "",
        Description: ""
    });


    const [showPicker, setShowPicker] = React.useState(false);
    const [isLabelOn, setIsLabelOn] = React.useState(false);

    const [labelsChecked, setLabelsChecked] = useState({})
    const [labelIndexForUser, setLabelIndexForUser] = useState("")

    const [deletePropModal, setDeletePropModal] = useState(false);
    const [deleteLading, setDeleteLading] = useState(false);

    const [uploadImagesLoading, setUploadImagesLoading] = useState(false);
    // const [deleteId, setDeleteId] = useState("");

    const [propKey, setPropKey] = React.useState(0);

    const [boughtTmp, setBoughtTmp] = useState(false)


    const [showShareModal, setShowShareModal] = useState(false)

    const navigate = useNavigate();


    const userInfo = useUserStore((state) => state.userInfo)
    const setUserInfo = useUserStore((state) => state.setUserInfo)

    const accessToken = useUserStore((state) => state.accessToken)
    const locationId = useUserStore((state) => state.locationId)






    const [filingMobile, setFilingMobile] = useState(userInfo.AgencyMobile);


    const { propInfo } = props




    useEffect(() => {
        // var time = propInfo.LastModified
        // getUsers()
        // console.log(moment(moment.unix(propInfo.LastModified).format("jYYYY/jMM/jDD")).fromNow())
        // console.log("propInfo.LastModified", propInfo.LastModified)
        // console.log("propInfo.LandLord",propInfo.LandLord)
        if (Cookies.get('agency') && JSON.parse(Cookies.get('agency')) && JSON.parse(Cookies.get('agency')).Templates && JSON.parse(Cookies.get('agency')).Templates.length) {
            let agencyTemplate = JSON.parse(Cookies.get('agency')).Templates[0].Content
            console.log("agencyTemplate", agencyTemplate)
            for (const key in messageTemplate) {
                let x = (messageTemplate[key].replaceAll(/\p{Emoji}/gu, "")).trim()
                // console.log('[${x}]', `[${ x }]`,messageTemplate[key] )

                if (propInfo[key] || propInfo[key] == 0) {
                    console.log('[${x}]', `[${x}]`, messageTemplate[key])

                    agencyTemplate = agencyTemplate.replaceAll(`[${x}]`, propInfo[key])
                }
                else
                    agencyTemplate = agencyTemplate.replaceAll(`[${messageTemplate[key]}]`, "-")

            }

            console.log("agencyTemplate", agencyTemplate)
            setTextTemplate(agencyTemplate)



        }

        console.log("agency coockie", getUserToken())

    }, [])

    const dataFetchedRef = useRef(false);

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

    }, [])



    useEffect(() => {
        setShowCommissionPrice(wordifyfa(commissionPrice))


    }, [commissionPrice])

    const { enqueueSnackbar } = useSnackbar();

    const handleShareModalOpen = (id) => {
        setShowShareModal(true);
    };
    const handleShareModalClose = () => {
        setShowShareModal(false);
    };

    const handleClickOpenDeletePropModal = (id) => {
        setDeletePropModal(true);
    };
    const handleDeletePropModalClose = () => {
        setDeletePropModal(false);
    };

    // const handleShareModalOpen = () => {
    //     setShareModal(true);
    // };
    // const handleShareModalClose = () => {
    //     setShareModal(false);
    // };

    const handleBuyingDescModalOpen = () => {
        setBuyingDesc(true);
    };
    const handleBuyingDescModalClose = () => {
        setBuyingDesc(false);
    };

    const handleRelationsModalOpen = () => {
        setRelationModal(true);
    };
    const handleRelationsModalClose = () => {
        setRelationModal(false);
    };

    const [saveToGoogleModal, setSaveToGoogleModal] = useState(false);
    const [googleLoading, setGoogleLoading] = useState(false);

    const handlesSveToGoogleModalOpen = () => {
        setSaveToGoogleModal(true);
    };
    const handlesSveToGoogleModalClose = () => {
        setSaveToGoogleModal(false);
    };




    const handleSaveToGoogle = async () => {
        setGoogleLoading(true)

        // tokenClient.callback = async (resp) => {
        //     if (resp.error !== undefined) {
        //         throw (resp);
        //     }
        // };

        const title = rememberState.Title
        const desc = rememberState.Description;
        const date = rememberState.DueDate;
        const start = "0";
        const end = "0";

        const startTime = new Date(date).toISOString();
        const endTime = new Date(date).toISOString();

        var event = {
            summary: title,
            location: "Google Meet",
            description: desc,
            start: {
                dateTime: startTime,
                timeZone: "America/Los_Angeles"
            },
            end: {
                dateTime: endTime,
                timeZone: "America/Los_Angeles"
            },
            recurrence: ["RRULE:FREQ=DAILY;COUNT=2"],
            attendees: [
                { email: "abc@google.com" },
                { email: "xyz@google.com" }
            ],
            reminders: {
                useDefault: false,
                overrides: [
                    { method: "email", minutes: 24 * 60 },
                    { method: "popup", minutes: 10 }
                ]
            }
        };

        console.log(event)

        if (gapi.client.getToken() === null) {

            await new Promise((resolve, reject) => {
                try {
                    // Settle this promise in the response callback for requestAccessToken()
                    tokenClient.callback = (resp) => {
                        if (resp.error !== undefined) {
                            reject(resp);
                        }
                        // GIS has automatically updated gapi.client with the newly issued access token.
                        console.log('gapi.client access token: ' + JSON.stringify(gapi.client.getToken()));


                        // localStorage.setItem('googleToken', JSON.stringify(gapi.client))

                        resolve(resp);
                    };
                    tokenClient.requestAccessToken();


                } catch (err) {
                    console.log(err)
                }
            });

        } else {
            // Skip display of account chooser and consent dialog for an existing session.
            // const token = JSON.parse(localStorage.getItem('googleToken'))
            // console.log("token",token)
            console.log('gapi.client.getToken()', JSON.parse(localStorage.getItem('googleToken')).getToken())
            tokenClient.requestAccessToken({ prompt: '' });
        }

        var request = gapi.client.calendar.events.insert({
            calendarId: "primary",
            resource: event
        });

        request.execute(function (event) {
            console.log(event.htmlLink);
        });


        handlesSveToGoogleModalClose()
        setGoogleLoading(false)
    }


    const handleRememberModalOpen = () => {
        setRememberModal(true);
    };
    const handleRememberModalClose = () => {
        setRememberModal(false);
    };

    const handleMoreOptionsModalClick = () => {
        setOpenMoreOptionsModal(true);
    };
    const handleMoreOptionsModalClose = () => {
        setOpenMoreOptionsModal(false);
    };

    const handleLabelsModalClick = async () => {
        setOpenLabelsModal(true);
        setIsLabelOn(true)
        setLabelsLoading(true)
        try {
            const response = await http({
                url: "/webapp/labels",
                method: "POST",
                data: {
                    "Type": 1
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })
            console.log(response)
            if (response.data.result.result) setLabels(response.data.result.result)
        } catch (e) {
            console.error(e);
        }

        try {
            const response2 = await http({
                url: "/webapp/entities/labels",
                method: "POST",
                data: {
                    "EntityId": propInfo.Id,
                    "EntityType": 1
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })
            console.log("/entities/labels", response2)
            if (response2.data.result.result) {
                let tmpLabelsChecked = {}
                response2.data.result.result.map(item => {
                    tmpLabelsChecked[item.LabelId] = {}
                    tmpLabelsChecked[item.LabelId][`showPicker${item.LabelId}`] = false
                    tmpLabelsChecked[item.LabelId]["id"] = item.LabelId
                    tmpLabelsChecked[item.LabelId]["AgencyName"] = item.FullName
                    tmpLabelsChecked[item.LabelId]["AssignedUser"] = item.AssignedUser
                    tmpLabelsChecked[item.LabelId]["DailyReminder"] = +item.DailyReminder
                    tmpLabelsChecked[item.LabelId]["RemindDate"] = +item.RemindDate
                    tmpLabelsChecked[item.LabelId]["RepeatDays"] = item.RepeatDays
                })

                setLabelsChecked(tmpLabelsChecked)

            }
        } catch (e) {
            console.error(e);
        }

        setLabelsLoading(false)

    };
    const handleLabelsModalClose = () => {
        setIsLabelOn(false)
        setOpenLabelsModal(false);
        setLabelsChecked({})
    };

    const handleOpenOtpCode = () => {
        setOpenOtpCode(true);
    };
    const handleOtpCodeClose = () => {
        setOpenOtpCode(false);
    };

    const handleOpenContactModal = () => {
        setContactModal(true);
    };
    const handleContactModalClose = () => {
        setContactModal(false);
    };

    const handleMobileModal = () => {
        setMobileModal(true);
    };
    const handleMobileModalClose = () => {
        setMobileModal(false);
    };

    const handleArchiveModal = () => {
        setArchiveModal(true);
    };
    const handleArchiveModalClose = () => {
        setArchiveModal(false);
    };

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    };
    const handleToggleBackdrop = () => {
        setOpenBackdrop(!openBackdrop);
    };


    const handlePlusUser = () => {
        let tmp = [...commissionUsers]
        tmp.push({ AgencyId: "", Price: "", Name: "" })
        setCommissionUsers(tmp)
    }


    const handleSendOtpCode = () => {
        if (otpCode != "") {
            setSendOtpLoading(true)
            try {
                http({
                    url: "https://payeshsoft.ir/api/divar/validate-otp",
                    method: "POST",
                    data: {
                        "phone": userInfo.AgencyMobile,
                        "code": otpCode
                    }
                }).then((res) => {
                    console.log("divar/validate-otp", res)
                    if (res.status == 200) {
                        try {
                            http({
                                url: "/divar/set-login-token",
                                method: "POST",
                                data: {
                                    "Mobile": userInfo.AgencyMobile,
                                    "AgencyId": userInfo.Id,
                                    "Token": res.data.token
                                }
                            }).then((setTokenRes) => {
                                if (setTokenRes.data.result == false) {
                                    const variant = 'error'
                                    enqueueSnackbar(setTokenRes.data.message, { variant });
                                    setSendOtpLoading(false)

                                } else if (setTokenRes.data.result.IsSet) {
                                    try {
                                        http({
                                            url: "/wallet/file/buy",
                                            method: "POST",
                                            data: {
                                                "Properties": [propInfo.Id],
                                                "LocationId": locationId
                                            },
                                            headers: {
                                                "Authorization": `Bearer ${accessToken}`
                                            }
                                        }).then((res) => {
                                            // console.log("checkout_url", res.result.checkout_url)

                                            if (res.data.result == false) {
                                                const variant = 'error'
                                                enqueueSnackbar(res.data.message, { variant });
                                                setSendOtpLoading(false)

                                            } else {
                                                const variant = 'success'
                                                enqueueSnackbar("فایل با موفقیت خریداری شد.", { variant });
                                                // window.open(res.data.result.checkout_url, '_blank', 'noreferrer');
                                                props.handleBuyingFiles(propInfo.Id)
                                                setSendOtpLoading(false)

                                            }


                                        });

                                    } catch (e) {
                                        console.error(e);
                                        if (e.result.data.result == false) {
                                            const variant = 'error'
                                            enqueueSnackbar(e.response.data.message, { variant });
                                        }


                                        setSendOtpLoading(false)

                                    }
                                }
                                setSendOtpLoading(false)
                            });

                        } catch (e) {
                            console.error(e);
                            if (e.result.data.result == false) {
                                const variant = 'error'
                                enqueueSnackbar(e.response.data.message, { variant });
                            }


                            setSendOtpLoading(false)

                        }




                    } else {
                        const variant = 'error'
                        enqueueSnackbar(res.data.resualt.message, { variant });
                        setSendOtpLoading(false)
                    }


                });

            } catch (e) {
                console.error(e);
                if (e.result.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }


            }
        }

    }




    const handleUploadImagesLoadingClose = () => {
        setUploadImagesLoading(false)
    }

    const handleUpdateProp = async (uploudedPic, newPropInfo) => {
        const temp = { ...newPropInfo }
        temp.Pictures = uploudedPic
        temp.ImageCount = uploudedPic.length
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: `/properties/${temp.Id}`,
                method: "POST",
                data: temp,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log(res.data.result)
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("عکس ها با موفقیت بارگذاری شدند.", { variant });
                    setUploadImagesLoading(false)
                } else {
                    setUploadImagesLoading(true)
                    const variant = 'error'
                    enqueueSnackbar("بارگذاری تصاویر با مشکل مواجه شد.", { variant });
                }

            });
        } catch (e) {
            console.error(e);
            setUploadImagesLoading(false)

        }
    }

    const uploadImages = async (pics, newPropInfo) => {
        setUploadImagesLoading(true)

        console.log("pics", pics)
        console.log("newPropInfo", newPropInfo)
        var uploudedPic = []
        for (const item of pics) {
            let formData = new FormData();
            formData.append("Prefix", JSON.parse(Cookies.get('agency')).Id)
            formData.append("Link", `https://ws.iranamlaak.net/upload/property/00000000-0000-0000-0000-000000000000/${propInfo.Id}/${item}`,)
            formData.append("Token", "075bdf37-4038-495c-a9b9-85a0826ffa62")
            formData.append("AppType", "Website")
            try {
                const res = await http({
                    // url of the api endpoint (can be changed)
                    url: "/upload-via-link.php",
                    method: "POST",
                    data: formData
                })
                console.log("res", res)
                if (res.data.Name)
                    uploudedPic.push(res.data.Name)


                // if (index >= pics.length)
                //     console.log("index",index)
            } catch (e) {
                console.error(e);
            }
        }

        console.log("uploudedPic", uploudedPic)
        if (uploudedPic.length) {
            handleUpdateProp(uploudedPic, newPropInfo)
        } else {
            const variant = 'error'
            enqueueSnackbar("بارکذاری عکس ها با مشکل مواجه شد.", { variant });
            setUploadImagesLoading(false)
        }
    }


    const saveThisProperty = async (prop) => {

        handleToggleBackdrop()
        let newPropInfo = {}

        console.log("prop[0]", prop[0])
        newPropInfo = { ...prop[0] }

        newPropInfo.Row = +userInfo.LastPropertyRow + 1
        newPropInfo.AgencyId = Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id
        newPropInfo.RegistrarDevice = 8
        newPropInfo.IsConfirmed = "1"
        newPropInfo.Prefix = Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id
        newPropInfo.LocationId = parseInt(newPropInfo.LocationId)

        try {
            await http({
                // url of the api endpoint (can be changed)
                url: "/properties/new/professional",
                method: "POST",
                data: newPropInfo,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log(res.data.result)
                if (res.data.result != false) {
                    const variant = 'success'
                    enqueueSnackbar("ملک شما با موفقیت ثبت شد.", { variant });
                    const userTmp = { ...userInfo }
                    userTmp.LastPropertyRow = +userTmp.LastPropertyRow + 1
                    setUserInfo(userTmp)

                    newPropInfo.Id = res.data.result[0].PropertyId
                    console.log("newPropInfo", newPropInfo)



                    uploadImages(propInfo.Pictures, newPropInfo)
                }
                handleCloseBackdrop()
            });
        } catch (e) {
            console.error(e);

            handleCloseBackdrop()
        }
    }

    const handleBuyFile = () => {
        console.log("credit", userInfo.Credit)
        console.log("FilePrice", propInfo.FilePrice)

        if (userInfo.Credit >= propInfo.FilePrice) {
            setBuyLoading(true)
            console.log("buyLoading", buyLoading)
            try {
                http({
                    url: "/divar/agency-has-token",
                    method: "POST",
                    data: {
                        "AgencyId": userInfo.Id,
                    }
                    ,
                    // headers: {
                    //     "Authorization": `Bearer ${accessToken}`
                    // }
                }).then((res) => {
                    // console.log("checkout_url", res.result.checkout_url)

                    if (res.data.result == false) {
                        const variant = 'error'
                        enqueueSnackbar(res.data.message, { variant });
                    } else if (res.data.result.Has) {
                        try {
                            http({
                                url: "/wallet/file/buy",
                                method: "POST",
                                data: {
                                    "Properties": [propInfo.Id],
                                    "LocationId": locationId
                                },
                                headers: {
                                    "Authorization": `Bearer ${accessToken}`
                                }
                            }).then((res) => {
                                // console.log("checkout_url", res.result.checkout_url)

                                if (res.data.result == false) {
                                    const variant = 'error'
                                    enqueueSnackbar(res.data.message, { variant });
                                } else {
                                    const variant = 'success'
                                    enqueueSnackbar("فایل با موفقیت خریداری شد.", { variant });


                                    props.handleBuyingFiles(propInfo.Id)
                                    saveThisProperty(res.data.result.Properties)
                                }

                                setBuyLoading(false)
                            });

                        } catch (e) {
                            console.error(e);
                            if (e.result.data.result == false) {
                                const variant = 'error'
                                enqueueSnackbar(e.response.data.message, { variant });
                            }
                            setBuyLoading(false)
                        }
                    } else {
                        handleMobileModal()
                    }
                });
            } catch (e) {
                console.error(e);
                if (e.result.data.result == false) {
                    const variant = 'error'
                    enqueueSnackbar(e.response.data.message, { variant });
                }
            }
        } else {
            const variant = 'error'
            enqueueSnackbar("کیف پول خود را شارژ کنید.", { variant });
            navigate("/settings")
            setBuyLoading(false)
        }
    }

    const handleDelete = async () => {
        setDeleteLading(true)
        try {
            await http({
                // url of the api endpoint (can be changed)
                url: `/properties/delete/${propInfo.Id}`,
                method: "POST",
                data: {
                    "LocationId": locationId
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {

                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar("ملک شما با موفقیت حذف شد.", { variant });
                    props.handleDeletedProps(propInfo.Id)

                }

                handleDeletePropModalClose()
                handleMoreOptionsModalClose()
                setDeleteLading(false)


            });
        } catch (e) {
            console.error(e);

            handleCloseBackdrop()
        }
    }

    const handleSendMobile = async () => {
        setSendMobileLoading(true)
        try {
            http({
                url: "https://payeshsoft.ir/api/divar/send-otp",
                method: "POST",
                data: {
                    "phone": filingMobile,
                }
            }).then((res) => {
                console.log("/divar/send-otp", res)
                if (res.status == 200) {
                    const variant = 'success'
                    enqueueSnackbar('کد تایید با موفقیت ارسال شد.', { variant });
                    handleOpenOtpCode()
                } else {
                    const variant = 'error'
                    enqueueSnackbar('متاسفانه خطایی رخ داده است.', { variant });
                }

                setSendMobileLoading(false)
            });

        } catch (e) {
            console.error(e);
            if (e.result.data.result == false) {
                const variant = 'error'
                enqueueSnackbar(e.response.data.message, { variant });
            }
            setSendMobileLoading(false)
        }
    }


    const handleCommisDate = (selectedDate) => {
        setRentReminderDate(+selectedDate.date)

    }


    //user modal

    const handleClickOpenUsersModal = (index = null, label = null) => {
        if (index || index == 0) {
            setIndexUserSelected(index)

        }
        if (label || label == 0) {
            setLabelIndexForUser(label)
            console.log("label", label)
        }
        getUsers(true)
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)
        setOpenUsersModal(true);
    };

    const handleOpenUsersModalClose = () => {
        setOpenUsersModal(false);
    };

    const [Users, setUsers] = React.useState([]);
    const [UserOffset, setUserOffset] = React.useState(1);
    const [HasMoreUsers, setHasMoreUsers] = React.useState(true);
    const [UsersLoading, setUsersLoading] = React.useState(false);
    const [inPlusingUser, setinPlusingUser] = React.useState(true);


    const getUsers = (resetState = false) => {
        if (resetState) {
            setUsers([])
            console.log("reset", Users)
            setPropKey(propKey => propKey++)
            setUserOffset(0);
            setHasMoreUsers(true)
        }

        setUsersLoading(true)
        try {
            http({
                // url of the api endpoint (can be changed)
                url: "/users/get-my-users",
                method: "GET",
                // data: {
                //     "Limit": 10,
                //     "Offset": UserOffset
                // },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log("users", res.data.result.Users);

                const tmpProp = [...Users]
                if (res.data.result.Users.length > 0) {
                    if (!resetState) {
                        res.data.result.Users.map((item, index) => {
                            tmpProp.push(item)
                        })
                        setUsers(tmpProp)

                        setPropKey(propKey => propKey++)
                    }
                    else
                        setUsers(res.data.result.Users)


                    setPropKey(propKey => propKey++)

                } else {
                    console.log("End")
                    setHasMoreUsers(false)
                    if (resetState) setUsers([])

                }

                console.log("users ff", Users)
                setUsersLoading(false)
                setTimeout(function () { setinPlusingUser(true) }, 1000)
            });

        } catch (e) {
            console.error(e);
            setUsersLoading(false)

        }


    }


    const onUsersScroll = () => {
        if (document.getElementById("users-content")) {

            const scrollTop = document.getElementById("users-content").scrollTop
            const scrollHeight = document.getElementById("users-content").scrollHeight
            const clientHeight = document.getElementById("users-content").clientHeight
            if (scrollTop + clientHeight >= scrollHeight && inPlusingUser) {
                setUserOffset(UserOffset => UserOffset + 1);
                // setSearchData({"name":"Offset","value":UserOffset})
                console.log("UserOffset", UserOffset)
                setinPlusingUser(false)
            }
        }
    }

    useEffect(() => {
        setTimeout(function () {
            if (document && typeof document.getElementById("users-content") !== 'undefined' && document.getElementById("users-content") !== null && Users.length > 0) {
                console.log("Users Use")
                document.getElementById("users-content").addEventListener('scroll', onUsersScroll)
                return () => document.getElementById("users-content").removeEventListener('scroll', onUsersScroll)
            }
        }, 500)


    }, [Users])

    useEffect(() => {
        console.log("offset use")

        if (HasMoreUsers && Users.length) {
            getUsers()
        }
    }, [UserOffset])


    const handleSetUserArchive = (user) => {
        let tmp = [...commissionUsers]
        tmp[indexUserSelected].Name = user.username
        tmp[indexUserSelected].AgencyId = user.Id
        console.log("users", commissionUsers)
        handleOpenUsersModalClose()
    }

    const handleSetCommissionPrice = (e, index) => {
        let tmp = [...commissionUsers]
        tmp[index].Price = e.target.value
        setCommissionUsers(tmp)
        console.log("users", commissionUsers)
    }

    const handleSetCommissionUsers = () => {
        setCommissionUsersLoading(true)
        let commissionUsersTmp = [...commissionUsers]
        commissionUsersTmp.map(item => {
            item = delete item.Name
        })

        try {
            http({
                // url of the api endpoint (can be changed)
                url: `/properties/${propInfo.Id}/archive`,
                method: "POST",
                data: {
                    "TotalPrice": commissionPrice,
                    "ContractCancelled": ContractCancelled,
                    "HasRentReminder": HasRentReminder,
                    "RentReminderDate": RentReminderDate,
                    "Users": commissionUsersTmp
                },
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            }).then((res) => {
                console.log(res)
                if (res.data.result) {
                    const variant = 'success'
                    enqueueSnackbar('ملک شما با موفقیت بایگانی شد.', { variant });
                }
                setCommissionUsersLoading(false)
            });

        } catch (e) {
            console.error(e);
            setCommissionUsersLoading(false)
        }
    }

    const formatJalali = (timestamp) => {
        console.log("timestamp", timestamp)
        try {
            return timestamp ? moment.unix(parseInt(timestamp / 1000)).format("jYYYY/jMM/jDD") : timestamp
        } catch (e) {
            console.log("error", e)
            return timestamp;
        }
    }




    const handleAddEntityLabel = (id) => {
        document.getElementById(`label-${id}`).classList.toggle("label-selected")

        let labelsCheckedTmp = { ...labelsChecked }

        if (id in labelsCheckedTmp)
            delete labelsCheckedTmp[id]
        else {
            labelsCheckedTmp[id] = { RemindDate: +(new Date()) }
            labelsCheckedTmp[id][`showPicker${id}`] = false
            labelsCheckedTmp[id].id = id
        }

        setLabelsChecked(labelsCheckedTmp)
    }

    useEffect(() => {
        console.log("labelsChecked", labelsChecked)

    }, [labelsChecked])

    const handleSetUserLabel = (user) => {
        let labelsCheckedTmp = { ...labelsChecked }
        console.log("labelIndexForUser", labelIndexForUser)
        labelsCheckedTmp[labelIndexForUser].AssignedUser = user.Id
        labelsCheckedTmp[labelIndexForUser].AgencyName = user.username
        setLabelsChecked(labelsCheckedTmp)

        handleOpenUsersModalClose()
    }

    const LabelReminderDateHandle = (selectedDate, index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        console.log("index", index)
        labelsCheckedTmp[index].RemindDate = +selectedDate.date
        setLabelsChecked(labelsCheckedTmp)

    }

    const handleLabelDailyReminder = (e, index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        console.log("index", index)
        if (e.target.checked)
            labelsCheckedTmp[index].DailyReminder = 1
        else
            labelsCheckedTmp[index].DailyReminder = 0

        setLabelsChecked(labelsCheckedTmp)
    }

    const closePickerHandle = (index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        labelsCheckedTmp[index][`showPicker${index}`] = false
        setLabelsChecked(labelsCheckedTmp)
    }

    const showPickerHandle = (index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        labelsCheckedTmp[index][`showPicker${index}`] = true
        setLabelsChecked(labelsCheckedTmp)
    }

    const handleSetRepeatDays = (e, index) => {
        let labelsCheckedTmp = { ...labelsChecked }
        labelsCheckedTmp[index]['RepeatDays'] = e.target.value
        console.log("e.target.value", e.target.value)
        setLabelsChecked(labelsCheckedTmp)
    }

    const handleSaveLabels = async () => {
        handleToggleBackdrop()
        console.log("labelsChecked", labelsChecked)
        let labels = {
            Labels: [],
            EntityId: propInfo.Id,
            EntityType: 1
        }
        for (const label in labelsChecked) {
            labels.Labels.push({
                "LabelId": parseInt(labelsChecked[label].id),
                "AssignedUser": labelsChecked[label].AssignedUser,
                "RemindDate": labelsChecked[label].RemindDate,
                "EntityId": propInfo.Id,
                "EntityType": 1,
                "DailyReminder": labelsChecked[label].DailyReminder,
                "RepeatDays": labelsChecked[label].RepeatDays,
            })
        }

        try {
            const response = await http({
                url: `/webapp/entities/save_labels`,
                method: "POST",
                data: labels,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })

            console.log(response)
            if (response.data.result.result) {
                const variant = 'success'
                enqueueSnackbar('نشان گذاری های شما با موفقیت ثبت شد.', { variant });
            }

        } catch (e) {
            console.error(e);
        }

        handleCloseBackdrop()

    }

    const handleMobileShare = () => {
        const shareData = {
            title: "پایش",
            text: textTemplate,
            url: `https://web.payesh.me/property/${propInfo.Id}`,
        }
        navigator.share(shareData);
    }

    const handleSendRememberState = async () => {
        handleToggleBackdrop()
        let tmp = { ...rememberState }

        tmp.EntityId = propInfo.Id

        try {
            const response = await http({
                url: `/webapp/reminders/create`,
                method: "POST",
                data: tmp,
                headers: {
                    "Authorization": `Bearer ${Cookies.get('token')}`
                }
            })

            console.log(response)
            if (response.data.result) {
                const variant = 'success'
                enqueueSnackbar('یادآوری با موفقیت ثبت شد.', { variant });
                handlesSveToGoogleModalOpen()
            }

        } catch (e) {
            console.error(e);
        }

        handleCloseBackdrop()
    }

    const handleNavigateToSettingLabels = () => {
        navigate("/settings", { state: { showLabel: true } });

    }



    return (<>
        <Box className={`dash-property-item ${propInfo.IsBought || (props.boughtFiles && props.boughtFiles.includes(propInfo.Id)) ? "IsBought p-1" : ""}`} id={propInfo.Id} onContextMenu={handleMoreOptionsModalClick} onClick={(e) => props.fromFiling && !propInfo.IsBought ? "" : navigate(`/property/${propInfo.Id}`)} >
            <Box sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', gap: '10px', fontSize: '13px', mb: 1 }}>
                <Box>
                    {propInfo.Row}
                </Box>
                {!props.fromFiling ? <IconButton onClick={(e) => {
                    e.stopPropagation()
                    handleMoreOptionsModalClick()
                }}>
                    <ThreeDotsIcon />
                </IconButton> : null}
            </Box>

            <Box sx={{ display: 'flex' }}>
                <Box sx={{ flex: '1' }}>

                    <Box sx={{ color: '#000000' }}>{propInfo.PropertyType} در {propInfo.PropertyArea}</Box>

                    <Box sx={{ fontSize: '13px', mt: 1 }}>{propInfo.Infrastructure ? `${propInfo.Infrastructure} متر مربع` : ""}</Box>
                    {propInfo.ForSale == 1 ? <Box sx={{ fontSize: '13px', mt: 3 }}>قیمت فروش {propInfo.SalePrice.toLocaleString()} تومان</Box> : null}
                    {propInfo.ForRent == 1 ? <Box sx={{ fontSize: '13px', mt: 3 }}>قیمت اجاره {propInfo.RentPrice1.toLocaleString()} تومان</Box> : null}
                    {propInfo.ForRent == 1 ? <Box sx={{ fontSize: '13px', mt: 3 }}>قیمت رهن {propInfo.MortgagePrice1.toLocaleString()} تومان</Box> : null}
                </Box>
                <Box className="prop-item-img">
                    {propInfo.Pictures && propInfo.Pictures[0] ? <img src={`https://ws.iranamlaak.net/upload/property/${propInfo.RegistrarAgency}/${propInfo.Id}/${propInfo.Pictures[0]}`} />
                        : <img src="/assets/img/no-photo-available.png" />}
                </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', fontSize: '13px', mt: 1 }}>
                <Box>
                    {props.fromFiling ?
                        !propInfo.IsBought && !props.boughtFiles.includes(propInfo.Id) ?

                            <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <Button sx={{ display: 'flex', gap: '10px', fontSize: "12px", bgcolor: "#D6ECD2!important", borderRadius: '50px', px: 2, py: 1, color: '#096767' }}
                                    // onClick={handleBuyFile}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        handleBuyingDescModalOpen()
                                    }}
                                >
                                    {!buyLoading ? <PlusGreenIcon /> : <img src="/assets/img/ladng2.gif" width="20" />}اضافه به پایش
                                </Button>
                                {/* <Box>{propInfo.FilePrice.toLocaleString()} تومان</Box> */}
                            </Box>
                            : <Box sx={{ display: 'flex', gap: '10px', fontSize: "13px", color: '#096767' }} >
                                <CheckIcon />به پایش اضافه شد
                            </Box>

                        : ""}
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '13px' }}>
                    {!props.fromFiling && propInfo.Agency ? <IconButton sx={{ bgcolor: '#D6ECD2!important' }} onClick={e => {
                        e.stopPropagation()
                        handleOpenContactModal()
                    }}>
                        <PhoneIcon />
                    </IconButton> : null}
                    <Box>
                        {/* {moment(moment.unix(propInfo.LastModified).format("YYYY/MM/DD")).locale('fa').fromNow()} */}
                        {jalaliMoment(new Date(propInfo.RegisterDate * 1000)).locale('fa').fromNow()}
                    </Box>
                </Box>

            </Box>

        </Box>

        {openMoreOptionsModal && <Dialog className="dialog-box"
            fullScreen
            open={openMoreOptionsModal}
            onClose={handleMoreOptionsModalClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                <Toolbar>

                    <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                        {/* انتخاب کنید */}
                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleMoreOptionsModalClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                </Toolbar>
            </AppBar>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', pt: 3, gap: '20px', px: 4 }}>

                <Button className="green-outline-btn" onClick={handleLabelsModalClick} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px', border: '0px !important', bgcolor: '#D6ECD2!important' }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <LabelsIcon />
                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>وظایف و نشانه گذاری ها</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                <Button className="green-outline-btn" onClick={handleRelationsModalOpen} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <HouseIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>ارتباطات</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                {/* {navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i) ?
                    <Button className="green-outline-btn" onClick={handleMobileShare} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <ShareIcon />
                            <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>اشتراک گذاری</Box>
                        </Box>
                        <ArrowRightIcon className="rotate-180-minus" />

                    </Button>
                    :

                    <Button className="green-outline-btn" onClick={handleShareModalOpen} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <ShareIcon />
                            <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>اشتراک گذاری</Box>
                        </Box>
                        <ArrowRightIcon className="rotate-180-minus" />
                    </Button>} */}
                {propInfo?.RegistrarUser == getUserToken()?.UserId || getUserToken()?.IsMaster == 1 ? <Button className="green-outline-btn" onClick={handleShareModalOpen} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <ShareIcon />
                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>اشتراک گذاری</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button> : ""}
                {CheckPermissions(userInfo, "property_share") ? <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <SendIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>ارسال</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button> : ""}
                <Button className="green-outline-btn" onClick={handleRememberModalOpen} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <CalendarIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>یادآوری</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
                {CheckPermissions(userInfo, "property_edit") ? props.fromFiling ? propInfo.IsBought ? <Button className="green-outline-btn" onClick={() => navigate(`/property_edit/${propInfo.Id}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <PenIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>ویرایش</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button> : null : <Button className="green-outline-btn" onClick={() => navigate(`/property_edit/${propInfo.Id}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <PenIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>ویرایش</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button> : ""}
                {CheckPermissions(userInfo, "property_archive") ? <Button className="green-outline-btn" onClick={handleArchiveModal} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <BackUpIcon />
                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>بایگانی</Box>

                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />
                </Button> : ""}
                {CheckPermissions(userInfo, "property_delete") ? props.fromFiling ? propInfo.IsBought ? <Button className="green-outline-btn" onClick={handleClickOpenDeletePropModal} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <DelIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>حذف</Box>
                    </Box>
                    {/* <ArrowRightIcon className="rotate-180-minus" /> */}

                </Button> : null : <Button className="green-outline-btn" onClick={handleClickOpenDeletePropModal} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <DelIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>حذف</Box>
                    </Box>
                    {/* <ArrowRightIcon className="rotate-180-minus" /> */}

                </Button> : ""}
                {propInfo.LandLord && propInfo?.LandLord.Telephones.Mobile[0]?.value && <Button className="green-outline-btn" sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <a href={`sms:${propInfo.LandLord && propInfo?.LandLord && propInfo.LandLord && propInfo?.LandLord.Telephones.Mobile[0]?.value}`}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <MailIcon />

                            <Box className="flex-1" sx={{ color: '#096767', fontSize: '12px' }}>ارسال پیام</Box>
                        </Box>
                        <ArrowRightIcon className="rotate-180-minus" />
                    </a>
                </Button>}
                <Button className="green-outline-btn" onClick={() => navigate(`/property/adapt/${propInfo.Id}/${propInfo.Row}`)} sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1, px: 2, borderRadius: '25px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <RoundArrowsIcon />

                        <Box className="flex-1" sx={{ color: '#096767', fontSize: '13px' }}>انطباق سازی</Box>
                    </Box>
                    <ArrowRightIcon className="rotate-180-minus" />

                </Button>
            </Box>
        </Dialog>}


        {/* {openLabelsModal && <ModalComponent showModalState={openLabelsModal}
            handleModalClose={handleLabelsModalClose}
            modalTitle="نشان گذاری ها"
            modalSubmitBtn={handleSaveLabels}
            modalTitleSubmitBtn="ذخیره"
            hasSpecificParent={true}

            headerRightBtnFunction={handleNavigateToSettingLabels}
            modalHeaderRightBtn={true}
            headerRightBtnClass="rounded-50"
            headerRightBtnTitle={<SettingDarkGray />}
        >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", p: 2 }}>

                {
                    labels && labels.length > 0 ?
                        labels.map((item, index) => (
                            <Box sx={{ display: "flex", alignItems: "center" }} key={index}>
                                <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}></Box>
                                <Box sx={{ width: "100%" }} id={`label-${item.Id}`} className={`labels-entity ${item.Id in labelsChecked ? 'label-selected' : ''}`}>
                                    <Box className='border-0 labels-item' sx={{ p: 1, bgcolor: newShade(item.ColorCode, 40) }}>
                                        <Box className="circle-color" sx={{ bgcolor: item.ColorCode }}></Box>
                                        <Box sx={{ flex: "1", textAlign: "center", color: lightOrDark(item.ColorCode) == "light" ? "#5a5a5a!important" : "#fff!important" }}>
                                            {item.Text}
                                        </Box>
                                    </Box>
                                    {
                                        item.Id in labelsChecked ?
                                            <Box>
                                                <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal(null, item.Id)} sx={{ width: 'auto', mt: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', bgcolor: "#fff" }}>
                                                    <span> {labelsChecked[item.Id] && labelsChecked[item.Id].AgencyName ? `توسط ${labelsChecked[item.Id]?.AgencyName}` : ""}</span>
                                                    <ArrowRightIcon className='rotate-90' />
                                                </Box>
                                                <Box sx={{ display: "flex", gap: "5px", alignItems: "center", mt: 1 }}>
                                                    در تاریخ
                                                    <Box className="labelDate">
                                                        <InputBase value={formatJalali(labelsChecked[item.Id].RemindDate)} className='f-14' onClick={() => showPickerHandle(item.Id)} />
                                                        <Picker
                                                            isOpen={labelsChecked[item.Id][`showPicker${item.Id}`]}
                                                            config={config}
                                                            value={labelsChecked[item.Id] && labelsChecked[item.Id].RemindDate ? new Date(labelsChecked[item.Id].RemindDate) : new Date()}
                                                            initialValue={labelsChecked[item.Id] && labelsChecked[item.Id].RemindDate ? new Date(labelsChecked[item.Id].RemindDate) : new Date()}
                                                            minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                                            maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                                            onSubmit={(date) => LabelReminderDateHandle(date, item.Id)}
                                                            // onChange={(date) => LabelReminderDateHandle(date, item.Id)}
                                                            onClose={() => closePickerHandle(item.Id)}
                                                            highlightWeekends
                                                        />
                                                        <CalendarIcon width="30px" />

                                                    </Box>
                                                    یادآوری شود.
                                                </Box>
                                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                                    <Checkbox id={`daily-remind${index}`} sx={{ mr: "-10px" }} className='green-check' checked={labelsChecked[item.Id]["DailyReminder"]} onChange={e => handleLabelDailyReminder(e, item.Id)} />
                                                    <label for={`daily-remind${index}`} style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                                        به صورت روزانه تکرار شود تا
                                                        <Box className="labelDate" sx={{ width: "35px!important" }}>
                                                            <InputBase className='f-14' type="number" sx={{ textAlign: "center!important" }} value={labelsChecked[item.Id]["RepeatDays"]} onChange={e => handleSetRepeatDays(e, item.Id)} />
                                                        </Box>
                                                        روز
                                                    </label>
                                                </Box>

                                            </Box>
                                            : ""
                                    }
                                </Box>
                                <Box sx={{ width: "50px", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} >
                                    <Checkbox className='green-check f-16' onChange={e => handleAddEntityLabel(item.Id)} checked={item.Id in labelsChecked} />
                                </Box>
                            </Box>
                        ))
                        : !labelsLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                }
                {
                    labelsLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""

                }


            </Box>
        </ModalComponent>} */}

        <SetLabelsModal openLabelsModal={openLabelsModal} handleLabelsModalClose={handleLabelsModalClose} labels={labels} isLabelOn={isLabelOn} Id={propInfo?.Id} />


        {mobileModal && <Dialog className="dialog-box"
            fullScreen
            open={mobileModal}
            onClose={handleMobileModalClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                <Toolbar>

                    <Typography sx={{ mx: 'auto' }} component="div">
                        شماره همراه خود را وارد کنید
                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleMobileModalClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                </Toolbar>
            </AppBar>
            <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                <Box>
                    <Box className="inputs-container" sx={{ width: 'auto' }}>
                        <InputBase id='deposit' inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} type='tel' value={filingMobile} onChange={(e) => setFilingMobile(e.target.value)} placeholder='' />
                    </Box>
                </Box>
            </Box>
            <Button className='green-btn' onClick={handleSendMobile} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>
                {
                    !sendMobileLoading ? "ارسال" : <img src="/assets/img/ladng2.gif" width="40" />
                }
            </Button>
        </Dialog>}

        {openOtpCode && <Dialog className="dialog-box"
            fullScreen
            open={openOtpCode}
            onClose={handleOtpCodeClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                <Toolbar>

                    <Typography sx={{ mx: 'auto' }} component="div">
                        کد ارسال شده به شماره {filingMobile} وارد کنید
                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleOtpCodeClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                </Toolbar>
            </AppBar>
            <Box sx={{ px: 2, mt: 3, color: '#8F8F8F' }}>
                <Box>
                    <Box className="inputs-container" sx={{ width: 'auto' }}>
                        <InputBase id='deposit' value={otpCode} inputProps={{ pattern: "\d*", maxlength: "11", dir: "rtl" }} type='tel' onChange={(e) => setOtpCode(e.target.value)} placeholder='' />
                    </Box>
                </Box>
            </Box>
            <Button className='green-btn' onClick={handleSendOtpCode} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>
                {
                    !sendOtpLoading ? "ارسال" : <img src="/assets/img/ladng2.gif" width="40" />
                }
            </Button>
        </Dialog>}

        {ContactModal && <PropertyContactModal ContactModal={ContactModal} handleContactModalClose={handleContactModalClose} propInfo={propInfo} />}

        {archiveModal && <Dialog className="dialog-box"
            fullScreen
            open={archiveModal}
            onClose={handleArchiveModalClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                <Toolbar>

                    {/* <Typography sx={{ mx: 'auto' }} component="div">
                       
                    </Typography> */}
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleArchiveModalClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                </Toolbar>
            </AppBar>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: "10px", pt: 3, px: 1, color: '#8F8F8F', paddingBottom: '80px' }}>
                <Box sx={{ borderBottom: "1px solid #B1B1B1", pb: 1 }}>
                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                        if (e.target.checked)
                            setContractCancelled(1)
                        else
                            setContractCancelled(0)
                    }} />} label="مالک منصرف شد یا منتهی به قرارداد نشد" />
                </Box>
                <Box>
                    <label className='f-14 text-label'>مبلغ کل کمیسیون دریافتی</label>
                    <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }} >

                        <TextField
                            label=""
                            pattern="(\d)+"
                            value={commissionPrice}
                            onChange={e => setCommissionPrice(e.target.value)}
                            name="numberformat"
                            id="formatted-numberformat-input"
                            className='remove-underline dir-ltr'
                            InputProps={{
                                inputComponent: NumericFormatCustom,
                            }}
                            variant="standard"
                        />
                    </Box>
                    <Box className='f-13' sx={{ color: '#29A19C' }}>{showCommissionPrice} {showCommissionPrice != "" ? "تومان" : ""}</Box>
                </Box>
                {
                    commissionUsers && commissionUsers.map((item, index) => {
                        return <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', gap: "10px", color: '#8F8F8F' }} key={index}>
                            <Box>
                                <label className='f-14 text-label'>میزان سهم کاربر</label>
                                <Box className={`inputs-container`} onClick={() => handleClickOpenUsersModal(index, null)} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
                                    <span>{item.Name}</span>
                                    <ArrowRightIcon className='rotate-180-minus' />
                                </Box>
                            </Box>
                            <Box>
                                <label className='f-14 text-label'>مبلغ</label>
                                <Box className="inputs-container" sx={{ width: 'auto', mt: 1 }} >
                                    <TextField
                                        label=""
                                        pattern="(\d)+"
                                        value={item.Price}
                                        onChange={e => handleSetCommissionPrice(e, index)}
                                        name="numberformat"
                                        id="formatted-numberformat-input"
                                        className='remove-underline dir-ltr'
                                        InputProps={{
                                            inputComponent: NumericFormatCustom,
                                        }}
                                        variant="standard"
                                    />
                                </Box>
                                {/* <Box className='f-13' sx={{ color: '#29A19C' }}>{showCommissionPrice} {showCommissionPrice != "" ? "تومان" : ""}</Box> */}
                            </Box>
                        </Box>
                    })
                }
                <Button className="inputs-container w-100 border-0" onClick={handlePlusUser} sx={{ width: 'auto', my: 1, p: 1, display: 'flex', direction: 'ltr', justifyContent: 'center', gap: "10px", alignItems: 'center', bgcolor: "#F6F6F6" }}>
                    اضافه کردن کاربر
                    <PlusIcon width="13" height="13" />
                </Button>

                <Box sx={{ borderTop: "1px solid #B1B1B1", pt: 1 }}>
                    <FormControlLabel className='green-check' sx={{ mr: 0 }} control={<Checkbox onChange={(e) => {
                        if (e.target.checked)
                            setHasRentReminder(1)
                        else
                            setHasRentReminder(0)
                    }} />} label="موعد یادآوری سر رسید اجاره" />
                </Box>

                {HasRentReminder == 1 ? <Box>
                    <label className='f-14 text-label'>در تاریخ</label>
                    <Box className={`inputs-container`} sx={{ width: 'auto', mt: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>

                        <div className='flex-1 w-chile-100'>
                            {/* <DatePicker calendar={persian} placeholder="تاریخ ثبت"
                                locale={persian_fa} onChange={handleCommisDate} /> */}
                            <InputBase placeholder="تاریخ ثبت" value={formatJalali(RentReminderDate)} className='flex-1' onClick={() => setShowPicker(true)} />
                            <Picker
                                isOpen={showPicker}
                                config={config}

                                initialValue={new Date(RentReminderDate ? new Date(RentReminderDate) : new Date())}
                                minDate={newDate({ year: parseInt(moment().format("jYYYY")) - 100, month: 1, day: 1 })}
                                maxDate={newDate({ year: parseInt(moment().format("jYYYY")), month: 12, day: 29 })}
                                onSubmit={handleCommisDate}
                                // onChange={handleCommisDate}
                                onClose={() => setShowPicker(false)}
                                highlightWeekends
                            />
                        </div>
                        <CalendarIcon />

                    </Box>
                </Box> : null}
            </Box>
            <Button className='green-btn' onClick={handleSetCommissionUsers} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>
                {
                    !commissionUsersLoading ? "ثبت" : <img src="/assets/img/ladng2.gif" width="40" />
                }
            </Button>
        </Dialog>}

        {openUsersModal && <Dialog className="dialog-box"
            fullScreen
            open={openUsersModal}
            onClose={handleOpenUsersModalClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', bgcolor: 'transparent', boxShadow: 'none', color: '#666666' }}>
                <Toolbar>

                    <Typography sx={{ mx: 'auto' }} variant="h6" component="div">
                        کاربران
                    </Typography>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleOpenUsersModalClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                    {/* <Button autoFocus color="inherit" onClick={handleClose}>
                                save
                            </Button> */}
                </Toolbar>
            </AppBar>
            <Box sx={{ px: 2, mt: 3, color: '#8F8F8F', height: "calc(100vh - 140px)!important", overflow: "auto" }} id="uset-content">
                <Box >
                    <Box sx={{ display: "flex", flexDirection: "column", gap: '15px', mt: "15px" }}>
                        {
                            Users && Users.length > 0 ?
                                Users.map((item, index) => (

                                    <Button className="userItem" sx={{ display: "flex", justifyContent: "space-between", width: "100%", p: 2 }} onClick={() => isLabelOn ? handleSetUserLabel(item) : handleSetUserArchive(item)} key={index}>
                                        <Box sx={{ display: "flex", gap: '5px', alignItems: 'center' }}>
                                            <Box sx={{ bgcolor: "#fff", borderRadius: "50%", width: "40px", height: "40px" }}>
                                            </Box>
                                            <Typography component="span">{item.username}</Typography>
                                        </Box>
                                        {/* <IconButton>
                                                <PenIcon2 />
                                            </IconButton> */}
                                    </Button>

                                ))
                                : !UsersLoading ? <Box sx={{ textAlign: 'center', mt: 2, width: '100%' }}>موردی یافت نشد!</Box> : ""
                        }
                        {
                            UsersLoading ? <Box sx={{ textAlign: 'center' }}>درحال بارگیری...</Box> : ""
                        }

                    </Box>
                </Box>
            </Box>
            <Button className='green-btn' onClick={handleOpenUsersModalClose} sx={{ width: "100%", mx: 'auto', position: 'fixed', bottom: '0px', left: '0px', right: '0px' }}>ثبت</Button>
        </Dialog>}

        {deletePropModal && <Dialog className="dialog-box"
            open={deletePropModal}
            onClose={handleDeletePropModalClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    آیا میخواهید این ملک را حذف کنید؟
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDeletePropModalClose}>خیر</Button>
                <Button onClick={handleDelete} autoFocus>
                    {!deleteLading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                </Button>
            </DialogActions>
        </Dialog>}



        {uploadImagesLoading && <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={uploadImagesLoading}
            onClose={handleUploadImagesLoadingClose}
            // TransitionComponent={state.Transition}
            message="در حال بارگذاری تصاویر..."

        />}

        {shareModal && <ModalComponent showModalState={shareModal}
            handleModalClose={handleShareModalClose}
            modalTitle=""
            hasSpecificParent={true}
            modalSubmitBtn=""
            modalTitleSubmitBtn="انتخاب">
            <ShareModal link={`https://web.payesh.me/property/${propInfo.Id}`} textToShare={textTemplate} />
        </ModalComponent>}

        {rememberModal && <ModalComponent showModalState={rememberModal}
            handleModalClose={handleRememberModalClose}
            modalTitle=""
            hasSpecificParent={true}
            modalSubmitBtn={handleSendRememberState}
            modalTitleSubmitBtn="ثبت">
            <Remember setRememberState={setRememberState} rememberState={rememberState} />
        </ModalComponent>}

        {saveToGoogleModal && <Dialog className="dialog-box"
            open={saveToGoogleModal}
            onClose={handlesSveToGoogleModalClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    آیا میخواهید این یادآوری در تقویم گوگل گوشیتان ذخیره شود؟
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handlesSveToGoogleModalClose}>خیر</Button>
                <Button onClick={handleSaveToGoogle} autoFocus>
                    {!googleLoading ? "بله" : <img src="/assets/img/ladng2.gif" width="20" />}
                </Button>
            </DialogActions>
        </Dialog>}


        {relationsModal && <RelationsModal relationsModal={relationsModal} handleRelationsModalClose={handleRelationsModalClose} propInfo={propInfo} />}

        {buyingDesc && <Dialog className="dialog-box"
            open={buyingDesc}
            onClose={handleBuyingDescModalClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            {/* <Dialog className="dialog-box"Title id="alert-dialog-title">
                        
                    </DialogTitle> */}
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    جهت دریافت فایل های ملکی بصورت روزانه و مشاهد جزئیات ملک نسخه ویندوزی پایش را از سایت زیر بصورت رایگان دریافت و نصب کنید:
                    <a href="https://app.payesh.me/" target="_blank" style={{ display: "block", textAlign: "left", color: "#29A19C" }}>App.payesh.me</a>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleBuyingDescModalClose}>باشه</Button>

            </DialogActions>
        </Dialog>}


        {showShareModal && <ShareModalCompo handleShareModalClose={handleShareModalClose} showShareModal={showShareModal} propId={propInfo?.Id} />}

    </>);
}

export default PropItem;